import {
  IonApp,
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonItem,
  IonLoading,
  IonRouterOutlet,
  IonRow,
  IonSplitPane,
  IonText,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import InstallPWA from "./components/InstallPWA/InstallPWA";
import Menu from "./components/Menu/Menu";
import Page from "./components/PageComponent/Page";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";

/* Theme variables */
import React from "react";
import { SessionProvider, useSession } from "./hooks/SessionContext";
import Login from "./pages/Login/Login";
import PageError from "./pages/PageError/PageError";
import Privacidad from "./pages/Privacidad";
import "./theme/general.css";
import "./theme/variables.css";

setupIonicReact();

//@ts-ignore
const App: React.FC = () => {
  const { cargandoSession } = useSession();

  if (cargandoSession === true) {
    return (
      <IonGrid>
        <IonRow className="LoginViewRow justify-content-center">
          <IonCol>
            <IonCard>
              <IonCardContent>
                <IonItem>
                  <IonText color="danger">
                    <IonLoading className="custom-loading" isOpen message="Cargando sesion existente" />
                  </IonText>
                </IonItem>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      </IonGrid>
    );
  } else {
    return (
      <IonApp>
        <IonReactRouter>
          <InstallPWA />
          <SessionProvider>
            <Switch>
              <Route path="/" exact={true}>
                <Redirect to="/Login" />
              </Route>
              <Route path="/Login" exact={true}>
                <Login />
              </Route>
              <Route path="/privacidad" exact={true}>
                <Privacidad />
              </Route>
              <Route path="/portal/" exact={true}>
                <Redirect to="/portal/Agenda" />
              </Route>
              <Route path="/portal/:name" exact={true}>
                <IonSplitPane contentId="main">
                  <Menu />
                  <IonRouterOutlet id="main">
                    <Page />
                  </IonRouterOutlet>
                </IonSplitPane>
              </Route>
              <Route path="/*" exact={true}>
                <Redirect to="/ErrorPage" />
              </Route>
              <Route path="/ErrorPage">
                <PageError />
              </Route>
            </Switch>
          </SessionProvider>
        </IonReactRouter>
      </IonApp>
    );
  }
};

export default App;
